import { ResourceCollaborator, ResourceType } from '@/services/database';
import { CollaboratorPermissionType } from '@/types';

export type { ResourceCollaborator, ResourceType };

export type CollaboratorRequestStatus = 'loading' | 'success' | 'error';

export type CollaboratorState = {
    collaborators: Partial<Record<string, ResourceCollaborator[]>>;
    requestStatus: Partial<Record<string, CollaboratorRequestStatus>>;
};

export const getResourceKey = (resourceType: ResourceType, resourceId: string) => `${resourceType}:${resourceId}`;

export type CollaboratorActions = {
    fetchCollaborators: (resourceType: ResourceType, resourceId: string) => Promise<void>;
    // Aliases
    addCollaborator: (
        resourceType: ResourceType,
        resourceId: string,
        memberId: string,
        role: CollaboratorPermissionType,
    ) => Promise<ResourceCollaborator | null>;
    updateCollaboratorPermission: (
        resourceType: ResourceType,
        resourceId: string,
        collaboratorId: string,
        role: CollaboratorPermissionType,
    ) => Promise<void>;
    removeCollaborator: (resourceType: ResourceType, resourceId: string, collaboratorId: string) => Promise<void>;
};
